<script>
	export let post;
	import { store } from "../store.js";
	import Calendar from "../assets/icons/Calendar.svelte";
	import Pin from "../assets/icons/Pin.svelte";
	import getVars from "../getVars";

	let cg_vars = getVars();

	let post_date = post.date_de_debut ? post.date_de_debut : post.post_date;
	let id = Math.floor(Math.random() * 100);
</script>

<div
	class="cs_post {post.post_type} {$store.options[$$props.id].loading !== true
		? 'loading'
		: ''}"
>
	{#if $store.options[$$props.id].filtres.afficher_contenu_epingle && post.sticky}
		<span class="cs_pin"><span>Contenu mis en avant</span><Pin /></span>
	{/if}
	<div class="cs_thumbnail">
		<a href={post.post_permalink} title={post.post_title}>
			{post.post_type}
			{#if post.post_thumbnail.file_url}
				<img
					src={post.post_thumbnail.file_url}
					alt={post.post_thumbnail.image_title}
				/>
			{:else if post.post_type === "formation" || post.post_type === "evenement" || post.post_type === "post" || post.post_type === "annonce_paysanne" || post.post_type === "panier"}
				<img
					src="{cg_vars.plugins_url}/front/public/images/default-{post.post_type}.png"
					alt=""
				/>
			{:else}
				<img src="{cg_vars.plugins_url}/front/public/images/default.jpg" alt="" />
			{/if}
		</a>
	</div>
	<div class="cs_post_bottom">
		<div class="cs_post_meta">
			<span class="cs_post_type {post.post_type}">
				{post.post_type_nice}
			</span>
			<span class="cs_post_date">
				<Calendar id={"calendar" + id} />
				{#if post.post_type === "formation" || post.post_type === "evenement"}
					{#if post.event_date_end}
						Du <b>{post.event_date}</b> au <b>{post.event_date_end}</b>
					{:else}
						Le <b>{post.event_date}</b>
					{/if}
				{:else}
					{post.time_ago}
				{/if}
			</span>
		</div>
		<h2>
			<a href={post.post_permalink} title={post.post_title}>{post.post_title}</a>
		</h2>
		<p class="cs_excerpt">{@html post.post_excerpt}</p>
	</div>
</div>

<style>
</style>
